import update from 'react-addons-update';
import {
  CREATE_ATTACHMENT_FOR_CREATE,
  UPLOAD_ATTACHMENT_FILE_START,
  ATTACHMENT_CREATE_API_FULFILLED,
  ATTACHMENT_CREATE_API_REJECTED,
  ATTACHMENT_UPLOAD_FAILED,
  UPDATE_UPLOAD_ATTACHMENTS_PROGRESS,
  ATTACHMENT_UPLOAD_FINISHED,
  CANCEL_ATTACHMENT_UPLOAD,
  CLEAR_FAILED_UPLOADING_ATTACHMENTS,
  CLEAR_UPLOADING_ATTACHMENTS_BY_ORIGIN,
  CREATE_ATTACHMENT_FROM_DOCUMENT_START
} from '../actions';
import {MIN_PROGRESS, MAX_PROGRESS} from '../../constants/attachments';

const initialAttachmentUploadReducerState = {
  uploadingAttachments: []
};

export default (state = initialAttachmentUploadReducerState, action) => {
  let uploadingAttachments;

  switch (action.type) {
    case CREATE_ATTACHMENT_FROM_DOCUMENT_START: {
      const fileId = action.meta.fileId;
      const attachment = action.payload;
      uploadingAttachments = [
        {
          ...attachment,
          fileId,
          id: fileId,
          name: attachment.document.name,
          progress: MAX_PROGRESS,
          isSaving: true
        }
      ].concat(state.uploadingAttachments);
      return update(state, {$merge: {uploadingAttachments}});
    }
    case CREATE_ATTACHMENT_FOR_CREATE:
      uploadingAttachments = [{...action.payload.attachment, progress: 100, isSaving: false, issueId: null}].concat(
        state.uploadingAttachments
      );
      return update(state, {$merge: {uploadingAttachments}});
    case UPLOAD_ATTACHMENT_FILE_START:
      uploadingAttachments = [{...action.payload, progress: MIN_PROGRESS, isSaving: true}].concat(
        state.uploadingAttachments
      );
      return update(state, {$merge: {uploadingAttachments}});
    case ATTACHMENT_CREATE_API_FULFILLED:
    case ATTACHMENT_CREATE_API_REJECTED:
      uploadingAttachments = state.uploadingAttachments.filter(a => a.id !== action.meta.fileId);
      return update(state, {$merge: {uploadingAttachments}});
    case ATTACHMENT_UPLOAD_FAILED:
      uploadingAttachments = state.uploadingAttachments.map(a =>
        a.id === action.payload.fileId ? {...a, isFailed: true, isSaving: false, progress: 100} : a
      );
      return update(state, {$merge: {uploadingAttachments}});
    case UPDATE_UPLOAD_ATTACHMENTS_PROGRESS: {
      // We always want to show 5% - 95% when file upload in progress.
      // 100% would only be shown on `ATTACHMENT_UPLOAD_FINISHED` event.
      const progress = Math.max(MIN_PROGRESS, Math.min(action.payload.progress, MAX_PROGRESS));
      uploadingAttachments = state.uploadingAttachments.map(a =>
        a.id === action.payload.fileId ? {...a, progress} : a
      );
      return update(state, {$merge: {uploadingAttachments}});
    }
    case CANCEL_ATTACHMENT_UPLOAD: {
      uploadingAttachments = state.uploadingAttachments.filter(a => a.id !== action.payload.fileId);
      return update(state, {$merge: {uploadingAttachments}});
    }
    case ATTACHMENT_UPLOAD_FINISHED: {
      if (!action.meta.createAfterUpload) {
        // This part is only called on create Issue form - as we don't call actual attachment creation - but we still want to show progress 100.
        uploadingAttachments = state.uploadingAttachments.map(a =>
          a.id === action.meta.fileId ? {...a, ...action.payload, progress: 100, isSaving: false} : a
        );
        return update(state, {$merge: {uploadingAttachments}});
      }
      return state;
    }
    case CLEAR_UPLOADING_ATTACHMENTS_BY_ORIGIN: {
      uploadingAttachments = state.uploadingAttachments.filter(file => file.origin !== action.payload);
      return update(state, {$merge: {uploadingAttachments}});
    }
    case CLEAR_FAILED_UPLOADING_ATTACHMENTS: {
      uploadingAttachments = state.uploadingAttachments.filter(file => !file.isFailed);
      return update(state, {$merge: {uploadingAttachments}});
    }
    default:
      return state;
  }
};
